import { message } from 'antd';
import { FC } from 'react';

const CustomMessage: FC<any> = () => {
  const [api, contextHolder] = message.useMessage();
  window.microMessage = {
    ...api,
    destroy: message.destroy
  };
  return (
    <div>
      {contextHolder}
    </div>
  );
};

export default CustomMessage;
